'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _userIdentityShape = require('./userIdentityShape');

var _userIdentityShape2 = _interopRequireDefault(_userIdentityShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listShape = _react.PropTypes.shape({
  agencyScope: _react.PropTypes.string,
  created: _react.PropTypes.string,
  updated: _react.PropTypes.string,
  id: _react.PropTypes.number,
  intendedLocale: _react.PropTypes.string,
  isPrivate: _react.PropTypes.bool,
  itemCount: _react.PropTypes.number,
  language: _react.PropTypes.string,
  listType: _react.PropTypes.string,
  name: _react.PropTypes.string,
  owner: _userIdentityShape2.default
});

exports.default = listShape;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/bc-prop-types/lib/components/listShape.js
// module id = 301
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14